import { apiClient } from '@/lib/api-client'
import { request } from '@/lib/request'

interface InvoicePdfVersionResponse {
  id: string
  invoiceId: string
  versionNumber: number
  generatedAt: string
  isArchived: boolean
  generatedBy: {
    id: string
    name: string
  }
}

interface InvoicePdfSignedUrlResponse {
  url: string
  filename: string
  expiresAt: string
}

export const generateInvoicePdf = (invoiceId: string) =>
  request<InvoicePdfVersionResponse>(() =>
    apiClient.api.invoicePdfControllerGeneratePdf({ invoiceId }),
  )

export const listInvoicePdfVersions = (invoiceId: string) =>
  request<InvoicePdfVersionResponse[]>(() =>
    apiClient.api.invoicePdfControllerListVersions({ invoiceId }),
  )

export const getInvoicePdfVersionSignedUrl = (invoiceId: string, versionId: string) =>
  request<InvoicePdfSignedUrlResponse>(() =>
    apiClient.api.invoicePdfControllerGetVersionSignedUrl({ invoiceId, versionId }),
  )

export const getInvoicePdfLatestSignedUrl = (invoiceId: string) =>
  request<InvoicePdfSignedUrlResponse>(() =>
    apiClient.api.invoicePdfControllerGetLatestSignedUrl({ invoiceId }),
  )
